import { render, staticRenderFns } from "./CabinetSidebar.vue?vue&type=template&id=f0b6fc0a&scoped=true"
import script from "./CabinetSidebar.vue?vue&type=script&lang=js"
export * from "./CabinetSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b6fc0a",
  null
  
)

export default component.exports